import { Button, Card, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { StationTable } from '../components/StationTable';
import { useStations } from '../hooks/useStations';

/**
 * Listado de Cargadores (US-2.2, `/cargadores`) — paginación server-side vía
 * `useStations`. Solo `SUPER_ADMIN` llega acá (guard de ruta), por eso el CTA de alta
 * se muestra siempre sin chequear permisos. El CTA apunta al alta (`/cargadores/nuevo`).
 */
export function StationsListPage() {
  const navigate = useNavigate();
  // El backend ya excluye las INACTIVE por defecto: no hace falta forzar `status`.
  const stations = useStations();

  const openCreate = () => navigate('/cargadores/nuevo');
  const openDetail = (stationId: string) => navigate(`/cargadores/${encodeURIComponent(stationId)}`);

  return (
    <div className="cargadores-page">
      <div className="cargadores-page__header">
        <Typography.Title level={3} style={{ margin: 0 }}>
          Cargadores
        </Typography.Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>
          Nuevo cargador
        </Button>
      </div>

      <Card>
        <StationTable
          stations={stations.data}
          meta={stations.meta}
          loading={stations.loading}
          error={stations.error}
          filters={stations.filters}
          onFiltersChange={stations.setFilters}
          onOffsetChange={stations.setOffset}
          onRetry={stations.refresh}
          onCreate={openCreate}
          onSelect={openDetail}
        />
      </Card>
    </div>
  );
}
